import { Component, Input } from '@angular/core';
import { PopupFieldData } from 'src/app/features/designer-studio/edit-pdf-doc/models/doc.model';

@Component({
  selector: 'app-screen-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent {
  @Input() initOptions: PopupFieldData;
}
